// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("./IconV5.bs.js");
let DialogV5 = require("./DialogV5.bs.js");
let Intercom = require("../../../reason/common/Intercom.bs.js");
let Next__Image = require("../../../reason/next/Next__Image.bs.js");
let NukaCarousel = require("../../bindings/NukaCarousel.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let NukaCarousel$1 = require("nuka-carousel").default;
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let TailwindVariants = require("../../bindings/TailwindVariants.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let Webapi__Dom__Document = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Document.bs.js");
let ReactAriaComponents = require("react-aria-components");
let VisuallyHidden = require("@reach/visually-hidden").default;
let Webapi__Dom__HtmlElement = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__HtmlElement.bs.js");
let UseWindowSize = require("uikit/hooks/useWindowSize");

let CarouselImg = {};

function ImageGallery__Carousel$ResponsiveImage(props) {
  let imgSize = props.imgSize;
  let alt = props.alt;
  let image = props.image;
  let match = imgSize === "fullscreen" ? [
      image.fullscreen,
      1200,
      undefined
    ] : (
      imgSize === "small" ? [
          image.small,
          750,
          500
        ] : [
          image.large,
          1200,
          800
        ]
    );
  let src = match[0];
  if (imgSize === "fullscreen") {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(Next__Image.make, {
        src: src,
        fill: true,
        unoptimized: true,
        alt: alt,
        className: "object-contain"
      }),
      className: "w-full h-full relative"
    });
  } else {
    return JsxRuntime.jsx(Next__Image.make, {
      src: src,
      width: match[1],
      height: match[2],
      unoptimized: true,
      alt: alt,
      className: "object-contain w-full h-auto"
    });
  }
}

let ResponsiveImage = {
  largeWidth: 1200,
  largeHeight: 800,
  smallWidth: 750,
  smallHeight: 500,
  make: ImageGallery__Carousel$ResponsiveImage
};

function ImageGallery__Carousel$TransparentButton(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx(ReactAriaComponents.Button, {
    children: props.children,
    className: v => TailwindMerge.twMerge([
      "appearance-none border-0 bg-transparent p-0 m-0 rounded",
      TailwindVariants.Utils.focusRing({
        isFocusVisible: v.isFocusVisible
      }),
      className
    ]),
    onClick: props.onClick
  });
}

let TransparentButton = {
  make: ImageGallery__Carousel$TransparentButton
};

let selectedShadowClass = "shadow-[0_0_3px_1px_#28618d]";

let unselectedShadowClass = "shadow-[0_0_3px_1px_transparent]";

function thumbnailStyles(highlightSelected, isSelected) {
  let shadow = isSelected && highlightSelected ? selectedShadowClass : unselectedShadowClass;
  return TailwindMerge.twMerge([
    "transform transition-all ease-linear duration-100 cursor-pointer flex items-center justify-center text-base font-bold bg-black/10 hover:scale-110",
    shadow
  ]);
}

function ImageGallery__Carousel$ImageThumbnails(props) {
  let __onSelectExtra = props.onSelectExtra;
  let onSelect = props.onSelect;
  let __imageSize = props.imageSize;
  let __maxLength = props.maxLength;
  let selectedIndex = props.selectedIndex;
  let images = props.images;
  let __highlightSelected = props.highlightSelected;
  let highlightSelected = __highlightSelected !== undefined ? __highlightSelected : true;
  let maxLength = __maxLength !== undefined ? __maxLength : 12;
  let imageSize = __imageSize !== undefined ? __imageSize : 75;
  let onSelectExtra = __onSelectExtra !== undefined ? __onSelectExtra : prim => {};
  let makeThumbnail = (img, i) => JsxRuntime.jsx(ImageGallery__Carousel$TransparentButton, {
    onClick: param => onSelect(i),
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("img", {
        className: "object-cover",
        height: imageSize.toString(),
        src: img.thumb,
        width: imageSize.toString()
      }),
      className: thumbnailStyles(highlightSelected, selectedIndex === i),
      style: {
        height: imageSize.toString() + "px",
        width: imageSize.toString() + "px"
      }
    })
  }, img.thumb);
  return JsxRuntime.jsx("div", {
    children: images.length > (maxLength + 1 | 0) ? images.filter((param, i) => i < maxLength).map(makeThumbnail).concat([JsxRuntime.jsx(ImageGallery__Carousel$TransparentButton, {
          onClick: param => {
            onSelect(maxLength);
            onSelectExtra();
          },
          children: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: "+" + (images.length - maxLength | 0).toString()
            }),
            className: thumbnailStyles(highlightSelected, selectedIndex >= maxLength),
            style: {
              height: imageSize.toString() + "px",
              width: imageSize.toString() + "px"
            }
          })
        }, "extra")]) : images.map(makeThumbnail),
    className: "grid justify-center w-full mb-4 gap-4 px-4",
    style: {
      gridTemplateColumns: "repeat(auto-fit, " + imageSize.toString() + "px)"
    }
  });
}

let ImageThumbnails = {
  selectedShadowClass: selectedShadowClass,
  unselectedShadowClass: unselectedShadowClass,
  thumbnailStyles: thumbnailStyles,
  make: ImageGallery__Carousel$ImageThumbnails
};

let onImageClass = "absolute top-2.5 left-1/2 -translate-x-1/2 p-1.5 bg-black/40 text-white";

let aboveImageClass = "absolute -top-10 left-1/2 -translate-x-1/2 p-1.5 text-white";

function ImageGallery__Carousel$SlideNumber(props) {
  return JsxRuntime.jsx("div", {
    children: (props.index + 1 | 0).toString() + (" of " + (props.length.toString() + " photos")),
    className: Stdlib_Option.getOr(props.className, props.position === "onImage" ? onImageClass : aboveImageClass)
  });
}

let SlideNumber = {
  onImageClass: onImageClass,
  aboveImageClass: aboveImageClass,
  make: ImageGallery__Carousel$SlideNumber
};

let openModalButtonContainerClass = "absolute top-2.5 right-2.5 p-1.5 bg-black/40 cursor-pointer rounded z-10 text-white hover:bg-black/50";

let fullscreenSlideClass = "inline-flex items-center w-full h-[calc(100vh-190px)]";

let nextButton = JsxRuntime.jsxs(JsxRuntime.Fragment, {
  children: [
    JsxRuntime.jsx(VisuallyHidden, {
      children: "Next"
    }),
    JsxRuntime.jsx(IconV5.make, {
      icon: "arrow-right"
    })
  ]
});

let prevButton = JsxRuntime.jsxs(JsxRuntime.Fragment, {
  children: [
    JsxRuntime.jsx(VisuallyHidden, {
      children: "Previous"
    }),
    JsxRuntime.jsx(IconV5.make, {
      icon: "arrow-left"
    })
  ]
});

let defaultControlsConfig_containerClassName = NukaCarousel.defaultControlsConfig.containerClassName;

let defaultControlsConfig_nextButtonStyle = NukaCarousel.defaultControlsConfig.nextButtonStyle;

let defaultControlsConfig_prevButtonStyle = NukaCarousel.defaultControlsConfig.prevButtonStyle;

let defaultControlsConfig_pagingDotsContainerClassName = NukaCarousel.defaultControlsConfig.pagingDotsContainerClassName;

let defaultControlsConfig_pagingDotsStyle = NukaCarousel.defaultControlsConfig.pagingDotsStyle;

let defaultControlsConfig = {
  containerClassName: defaultControlsConfig_containerClassName,
  nextButtonClassName: "flex items-center text-white",
  nextButtonStyle: defaultControlsConfig_nextButtonStyle,
  nextButtonText: nextButton,
  prevButtonClassName: "flex items-center text-white",
  prevButtonStyle: defaultControlsConfig_prevButtonStyle,
  prevButtonText: prevButton,
  pagingDotsContainerClassName: defaultControlsConfig_pagingDotsContainerClassName,
  pagingDotsClassName: "px-1.5 py-px",
  pagingDotsStyle: defaultControlsConfig_pagingDotsStyle
};

function ImageGallery__Carousel$Carousel(props) {
  let imgSize = props.imgSize;
  let __maxThumbnails = props.maxThumbnails;
  let selectedIndex = props.selectedIndex;
  let onSelect = props.onSelect;
  let openModal = props.openModal;
  let images = props.images;
  let maxThumbnails = __maxThumbnails !== undefined ? __maxThumbnails : 24;
  let carouselRef = React.useRef(undefined);
  React.useEffect(() => {
    let document$1 = document;
    let body = Stdlib_Option.flatMap(Webapi__Dom__Document.asHtmlDocument(document$1), prim => Primitive_option.fromNullable(prim.body));
    let match = carouselRef.current;
    let match$1 = document$1.activeElement;
    if (match !== undefined && !(match$1 == null) && body !== undefined && imgSize === "fullscreen" && match$1 === Primitive_option.valFromOption(body)) {
      Stdlib_Option.forEach(Webapi__Dom__HtmlElement.ofElement(Primitive_option.valFromOption(match)), prim => {
        prim.focus();
      });
    }
  }, [selectedIndex]);
  let windowSize = UseWindowSize.useWindowSize();
  let maxDots = imgSize === "small" ? Math.min(windowSize.width - 50 | 0, 668) / 20 | 0 : (windowSize.width - 30 | 0) / 20 | 0;
  return JsxRuntime.jsxs("div", {
    children: [
      openModal !== undefined ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ImageGallery__Carousel$TransparentButton, {
            onClick: param => openModal(),
            children: JsxRuntime.jsx(IconV5.make, {
              icon: "full-size-view"
            })
          }),
          className: openModalButtonContainerClass
        }) : null,
      JsxRuntime.jsx(NukaCarousel$1, {
        beforeSlide: (_prev, nextIndex) => onSelect(nextIndex),
        children: images.map((img, index) => JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ImageGallery__Carousel$ResponsiveImage, {
            image: img,
            alt: index.toString(),
            imgSize: imgSize
          }),
          className: imgSize === "fullscreen" ? fullscreenSlideClass : "inline-flex items-center"
        }, img.thumb)),
        defaultControlsConfig: defaultControlsConfig,
        enableKeyboardControls: true,
        getControlsContainerStyles: position => {
          if (position !== "BottomCenter") {
            return {
              width: "auto"
            };
          }
          let widthPx = (maxDots * 20 | 0).toString() + "px";
          return {
            alignItems: "center",
            bottom: "-4px",
            display: "flex",
            justifyContent: "center",
            margin: "0 auto",
            minHeight: "24px",
            overflowX: "hidden",
            overflowY: "visible",
            width: widthPx
          };
        },
        slideIndex: selectedIndex
      }, windowSize.width.toString()),
      JsxRuntime.jsx(ImageGallery__Carousel$SlideNumber, {
        index: selectedIndex,
        length: images.length,
        position: imgSize === "fullscreen" ? "aboveImage" : "onImage"
      }),
      JsxRuntime.jsx(ImageGallery__Carousel$ImageThumbnails, {
        images: images,
        selectedIndex: selectedIndex,
        maxLength: maxThumbnails,
        onSelect: onSelect,
        onSelectExtra: openModal
      })
    ],
    ref: Primitive_option.some(element => {
      carouselRef.current = (element == null) ? undefined : Primitive_option.some(element);
    }),
    className: "[&>*:not(:last-child)]:mb-4 relative flex flex-col items-center",
    tabIndex: -1
  });
}

let Carousel = {
  openModalButtonContainerClass: openModalButtonContainerClass,
  fullscreenSlideClass: fullscreenSlideClass,
  nextButton: nextButton,
  prevButton: prevButton,
  defaultControlsConfig: defaultControlsConfig,
  make: ImageGallery__Carousel$Carousel
};

let className = "absolute top-2.5 left-1/2 -translate-x-1/2 p-1.5 bg-zinc-800/70 text-white text-sm font-medium rounded-md";

function ImageGallery__Carousel$LightCarousel$LightSlideNumber(props) {
  return JsxRuntime.jsx("div", {
    children: (props.index + 1 | 0).toString() + (" / " + props.length.toString()),
    className: className
  });
}

let LightSlideNumber = {
  className: className,
  make: ImageGallery__Carousel$LightCarousel$LightSlideNumber
};

let defaultHeightClassName = "h-[calc(100vh-190px)]";

function ImageGallery__Carousel$LightCarousel(props) {
  let selectedIndex = props.selectedIndex;
  let onSelect = props.onSelect;
  let openModal = props.openModal;
  let __heightClassName = props.heightClassName;
  let images = props.images;
  let heightClassName = __heightClassName !== undefined ? __heightClassName : defaultHeightClassName;
  let windowSize = UseWindowSize.useWindowSize();
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(NukaCarousel$1, {
        beforeSlide: (_prev, nextIndex) => onSelect(nextIndex),
        children: images.map(img => JsxRuntime.jsx(ImageGallery__Carousel$TransparentButton, {
          onClick: param => openModal(),
          children: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ImageGallery__Carousel$ResponsiveImage, {
              image: img,
              alt: "",
              imgSize: "small"
            }),
            className: TailwindMerge.twMerge([
              "inline-flex items-center w-full",
              heightClassName
            ])
          })
        }, img.thumb)),
        enableKeyboardControls: true,
        slideIndex: selectedIndex,
        withoutControls: true
      }, windowSize.width.toString()),
      JsxRuntime.jsx(ImageGallery__Carousel$LightCarousel$LightSlideNumber, {
        index: selectedIndex,
        length: images.length
      })
    ],
    className: "relative flex flex-col items-center"
  });
}

let LightCarousel = {
  LightSlideNumber: LightSlideNumber,
  defaultHeightClassName: defaultHeightClassName,
  make: ImageGallery__Carousel$LightCarousel
};

let closeBtnClass = "fixed top-0 right-0 p-5 cursor-pointer focus:outline-none z-[100]";

let modalClassName = "w-screen max-w-[120vh] m-0 p-0 bg-transparent rounded-none shadow-none h-full flex flex-col";

let overlayClassName = "bg-black/95 backdrop-blur-sm backdrop-brightness-75 backdrop-saturate-50 flex flex-col items-center px-0 pt-0 pb-0";

function ImageGallery__Carousel$CarouselDialog(props) {
  let onDismiss = props.onDismiss;
  return JsxRuntime.jsxs(DialogV5.make, {
    isOpen: props.isOpen,
    ariaLabel: "Image Gallery",
    onDismiss: onDismiss,
    customContent: true,
    size: "FullScreen",
    showCloseButton: false,
    overlayClassName: overlayClassName,
    modalClassName: modalClassName,
    transitionOnDestroyed: props.transitionOnDestroyed,
    children: [
      JsxRuntime.jsxs(ReactAriaComponents.Button, {
        children: [
          JsxRuntime.jsx(VisuallyHidden, {
            children: "Close"
          }),
          JsxRuntime.jsx(IconV5.make, {
            icon: "cancel",
            size: 24,
            className: "text-white"
          })
        ],
        style: {
          top: Intercom.getBannerHeight().toString() + `px`
        },
        className: param => closeBtnClass,
        onClick: param => onDismiss()
      }),
      JsxRuntime.jsx("div", {
        className: "flex justify-end"
      }),
      JsxRuntime.jsx("div", {
        children: props.children,
        className: "flex flex-col items-stretch w-full m-auto pt-16"
      })
    ]
  });
}

let CarouselDialog = {
  closeBtnClass: closeBtnClass,
  modalClassName: modalClassName,
  overlayClassName: overlayClassName,
  make: ImageGallery__Carousel$CarouselDialog
};

let Nuka;

exports.Nuka = Nuka;
exports.CarouselImg = CarouselImg;
exports.ResponsiveImage = ResponsiveImage;
exports.TransparentButton = TransparentButton;
exports.ImageThumbnails = ImageThumbnails;
exports.SlideNumber = SlideNumber;
exports.Carousel = Carousel;
exports.LightCarousel = LightCarousel;
exports.CarouselDialog = CarouselDialog;
/* nextButton Not a pure module */
